import { Component, Prop, Vue } from "vue-property-decorator";
@Component
class CommentHeader extends Vue {
  @Prop()
  private ctx: any;

  private spanStyle =
    "width:4px;height:4px;backgroundrgb(233,236,240);border-radius:50%;position:absolute;top:6px;background:rgb(233,236,240);";
  private span1 = this.spanStyle + "right:6px;";
  private span2 = this.spanStyle + "right:13px;";
  private span3 = this.spanStyle + "right:20px;";
  public render() {
    return (
      <div style="width:134px;height:100px;margin:0 auto;">
        <div style="width:100px;height:100px;background:rgb(233,236,240);border-radius:50%;position:relative">
          <div style="width:100px;height:70px;background:#fff;border-radius:4px;position:absolute;left:15px;top:14px;">
            <span style={this.span1} />
            <span style={this.span2} />
            <span style={this.span3} />
            <div style="width:88px;font-size:11px;line-height:11px;font-family:Avenir-Heavy;background:rgb(79,121,255);color:#fff;padding:7px 0;text-align:center;margin:26px auto 0;border-radius:4px;">
              Commenting
            </div>
            <img
              style="width:50px;position:absolute;left:74px;top:30px;"
              src={require("@/assets/icons-file/dialog/right-hand.png")}
              alt=""
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CommentHeader;
